import { POSA_FORMAT } from "@tootsweet/model/lottery/POSAType";
import { tt } from "../../../../utils/i18n/i18n";

export const POSA_PREVIEW_WIDTH = 247;
export const POSA_PREVIEW_HEIGHT = 247;

const LOREM_IPSUM =
  "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.";

const LOREM_IPSUM_TITLE = "DUMMY TITLE";

export const POSA_FORMAT_DESC: Record<POSA_FORMAT, string> = {
  flyer_a5: tt("posa_format_flyer_a5_desc"),
  flyer_a6: tt("posa_format_flyer_a6_desc"),
  stickers10x10: tt("posa_format_stickers10x10_desc"),
  stickers_dome: tt("posa_format_stickers_dome_desc"),
  a_long: tt("posa_format_a_long_desc"),

  businesscardsstandard: LOREM_IPSUM,

  chevalet_a5: LOREM_IPSUM,
  chevalet_a6: LOREM_IPSUM,
  kakemono: LOREM_IPSUM,
  poster_a2: LOREM_IPSUM,
  poster_a3: LOREM_IPSUM,
  poster_a4: LOREM_IPSUM,
  "online-ig-post": LOREM_IPSUM,
  "online-ig-story": LOREM_IPSUM,
  delivery_bag: LOREM_IPSUM,
  paper_menu: LOREM_IPSUM,
  print_on_bag: LOREM_IPSUM,
  print_on_packaging: LOREM_IPSUM,
  table_set: LOREM_IPSUM
};

export const POSA_FORMAT_ARRAY: Record<POSA_FORMAT, string> = {
  "online-ig-post": LOREM_IPSUM_TITLE,
  "online-ig-story": LOREM_IPSUM_TITLE,
  delivery_bag: LOREM_IPSUM_TITLE,
  paper_menu: LOREM_IPSUM_TITLE,
  print_on_bag: LOREM_IPSUM_TITLE,
  print_on_packaging: LOREM_IPSUM_TITLE,
  table_set: LOREM_IPSUM_TITLE,

  chevalet_a5: tt("posa_item_a5_display"),
  chevalet_a6: tt("posa_item_a6_display"),

  kakemono: tt("posa_item_kakemono"),

  poster_a2: tt("posa_item_poster_a2"),
  poster_a3: tt("posa_item_poster_a3"),
  poster_a4: tt("posa_item_poster_a4"),

  businesscardsstandard: tt("posa_item_business_card"),

  flyer_a5: tt("posa_flyer_a5"),
  flyer_a6: tt("posa_flyer_a6"),
  stickers10x10: tt("posa_sticker"),
  stickers_dome: tt("posa_sticker_dome"),
  a_long: tt("posa_format_a_long")
};
